<template>
  <div class="vertical-divider"></div>
</template>

<script>
export default {};
</script>

<style scoped>
.vertical-divider {
  width: 1px;
  height: 100%;
  background-color: #E5E7EB;
  margin: 0 24px;
}
</style>
